// extracted by mini-css-extract-plugin
module.exports = {"checkbox-input":"checkbox-input___1RdGJ","round-slider":"round-slider___2ZuPv","switch":"switch___3K6x4","isDisabled":"isDisabled___1Pw7O"};